module.exports = __webpack_public_path__ + "img/DSC_1110.f6eeaf53.jpg";